import { BackCardIcon, BoxPaddingIcon, DiamondIcon, FrontCardIcon, PaintIcon, Paragraph, TagIcon } from "@datagame/ui";
import classNames from "classnames/bind";

import { LibraryImageKind } from "../../../../gql/graphql";

import styles from "./ImageCategoryBadge.module.scss";

const cx = classNames.bind(styles);

export interface ImageCategoryBadgeProps {
  kind: LibraryImageKind;
}

export const ImageCategoryBadge = ({ kind }: ImageCategoryBadgeProps) => {
  const renderIcon = () => {
    if (kind === LibraryImageKind.GameBoard) {
      return <BoxPaddingIcon className={styles.gameBoardIcon} />;
    }
    if (kind === LibraryImageKind.Background) {
      return <PaintIcon className={styles.backgroundIcon} />;
    }
    if (kind === LibraryImageKind.Logo) {
      return <DiamondIcon className={styles.logoIcon} />;
    }
    if (kind === LibraryImageKind.CardBack) {
      return <FrontCardIcon className={styles.cardBackIcon} />;
    }
    if (kind === LibraryImageKind.CardFront) {
      return <BackCardIcon className={styles.cardFrontIcon} />;
    }
    return <TagIcon className={styles.posterIcon} />;
  };
  return (
    <div className={cx("badge", kind)}>
      {renderIcon()}
      <Paragraph size="small" weight="font-bold" className={cx("category", kind)}>
        {kind}
      </Paragraph>
    </div>
  );
};
